import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Products } from "../components/Products";
import { Manifesto } from "../components/Manifesto";
import { Ritual } from "../components/Ritual";
import { Testimonials } from "../components/Testimonials";
import { ContactNewsletter } from "../components/ContactNewsletter";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 150);
    }
  }, [hash]);

  return (
    <>
      <Hero />
      <Marquee />
      <Products />
      <Manifesto />
      <Ritual />
      <Testimonials />
      <ContactNewsletter />
    </>
  );
}
